<template>
  <table class="auctions__table mt-5">
    <thead>
      <tr>
        <th>{{I18n.t('table.number')}}</th>
        <th>{{I18n.t('employees.auctions_catalogs.payments.header.house_name')}}</th>
        <th>{{I18n.t('employees.auctions_catalogs.payments.header.name')}}</th>
        <th>{{I18n.t('employees.auctions_catalogs.payments.header.date')}}</th>
        <th>{{I18n.t('employees.auctions_catalogs.payments.header.bought_number')}}</th>
        <th>{{I18n.t('employees.auctions_catalogs.payments.header.summary')}}</th>
        <th>{{I18n.t('employees.auctions_catalogs.payments.header.paid_number')}}</th>
      </tr>
    </thead>

    <tbody>
      <PaymentsRow
        v-for="(auctionsCatalog, index) in auctionsCatalogs"
        :auctionsCatalog="auctionsCatalog"
        :auctionHouse="auctionsCatalog.auctionHouse"
        :index="index"
        :meta="meta"
        :key="auctionsCatalog.id"
      >
      </PaymentsRow>
    </tbody>
  </table>
</template>

<script>
  import PaymentsRow from './row';

  export default {
    name: 'PaymentsList',
    components: {
      PaymentsRow,
    },
    props: {
      auctionsCatalogs: Array,
      meta: Object,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/payments/auctions_catalogs/list.vue?45a67e9a